import React, { useState } from "react";
import Shell from "./Shell";
import type { User } from '@/shared/types';
import { HOME, type HomeState } from "@/shared/constants/home";
import { GameState } from "@/shared/constants/game";

function Home({ user, refetchUser, gameState }: { user: User | null, refetchUser: () => {}, gameState: GameState }) {
  const [ homeState, setHomeState ] = useState<HomeState>(HOME.NONE);

  return (
    <div>
        <Shell user={user} refetchUser={refetchUser} gameState={gameState} homeState={homeState} setHomeState={setHomeState}/>
    </div>
    )
}

export default Home;